import { render, staticRenderFns } from "./BuffetEpgCard.vue?vue&type=template&id=1a73e1ae"
import script from "./BuffetEpgCard.vue?vue&type=script&lang=ts"
export * from "./BuffetEpgCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports